import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { selectInfo } from "projects/money-movement-ui/src/app/account-info-header/reducers";
import { Subject, takeUntil } from "rxjs";

@Component({
    standalone: false,
    selector: 'mm-transaction-review-wire',
    templateUrl: './transaction-review-wire.component.html',
    styleUrls: ['./transaction-review-wire.component.scss']
})

export class TransactionReviewWireComponent implements OnInit, OnDestroy{
    readonly subtitle: string = 'From account details';

    isIra: boolean = false;

    destroy$: Subject<void> = new Subject<void>();
    
    constructor(private store: Store) {}

    ngOnInit(): void {
        this.store.select(selectInfo).pipe(takeUntil(this.destroy$)).subscribe((info) => {
            this.isIra = info.classifications.isIra;
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}